export default __webpack_public_path__ + "static/media/button_correct.12f9a6f8.png";